import { authHeader, handleResponse } from "../helpers";
export const dashboardImageService = {
  fetchDashboardImage,
};

function fetchDashboardImage() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}SliderMaster/getSliderMobile`,
    requestOptions
  ).then(handleResponse);
}
